import {
  ArrowLeftStroke,
  FileMultipleStroke,
  FloppyDisk1Stroke,
  Pencil1Stroke,
  PlusStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { AritoActionButton } from '@/components/custom/arito/action-button';
import AritoActionBar from '@/components/custom/arito/action-bar';

interface HeaderBarProps {
  title: string;
  subTitle?: string;
  mode: 'view' | 'edit' | 'add' | 'search';
  headerBar?: React.ReactNode;
  onSubmit?: () => void;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  onClose: () => void;
  form?: string;
  isEditDisabled?: boolean;
  isDeleteDisabled?: boolean;
  isCopyDisabled?: boolean;
}

export default function HeaderBar({
  title,
  subTitle,
  mode,
  headerBar,
  onSubmit,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  onClose,
  form,
  isEditDisabled = false,
  isDeleteDisabled = false,
  isCopyDisabled = false
}: HeaderBarProps) {
  const isViewMode = mode === 'view';
  console.log('Mode', mode);

  return (
    <AritoActionBar
      inForm={true}
      className='border-b border-gray-300'
      titleComponent={
        <div className='flex flex-col items-center justify-center lg:items-start lg:justify-start'>
          <h1 className='text-[length:var(--erp-action-bar-title-size)] font-bold'>
            {title || (mode === 'add' && 'Thêm')}
          </h1>
          {subTitle && <h2 className='text-xs text-gray-500'>{subTitle}</h2>}
        </div>
      }
    >
      {headerBar && headerBar}
      {!headerBar && (
        <>
          {isViewMode && onAdd && (
            <AritoActionButton title='Thêm' icon={PlusStroke} variant='primary' onClick={onAdd} />
          )}
          {isViewMode && onEdit && (
            <AritoActionButton
              title='Sửa'
              icon={Pencil1Stroke}
              variant='secondary'
              onClick={onEdit}
              disabled={isEditDisabled}
            />
          )}
          {isViewMode && onDelete && (
            <AritoActionButton
              title='Xóa'
              icon={Trash3Stroke}
              variant='destructive'
              onClick={onDelete}
              disabled={isDeleteDisabled}
            />
          )}
          {isViewMode && onCopy && (
            <AritoActionButton
              title='Sao chép'
              icon={FileMultipleStroke}
              variant='secondary'
              onClick={onCopy}
              disabled={isCopyDisabled}
            />
          )}

          {!isViewMode && (
            <AritoActionButton
              title='Lưu'
              icon={FloppyDisk1Stroke}
              variant='secondary'
              type='submit'
              form={form}
              onClick={onSubmit}
            />
          )}
          <AritoActionButton title='Đóng' icon={ArrowLeftStroke} variant='destructive' onClick={onClose} />
        </>
      )}
    </AritoActionBar>
  );
}
